import React from "react";

import "suneditor/dist/css/suneditor.min.css";
import SunEditor from "suneditor-react";
import plugins from "suneditor/src/plugins"; // IMPORTANT: default built-in plugins

function SunRichEditor(props) {
  const { defaultValue, onChange, height, setOptions = {} } = props;

  const defaultEditorOptions = {
    height: height,
    buttonList: [["bold", "font", "fontSize", "underline", "list", "align", "fontColor", "codeView"]],
  };

  const mergedOptions = {
    ...defaultEditorOptions,
    ...setOptions,
    buttonList: setOptions.buttonList || defaultEditorOptions.buttonList,
  };

  // IMPORTANT: If custom plugins are provided, include default plugins + custom plugins
  if (Array.isArray(setOptions.plugins) && setOptions.plugins.length > 0) {
    mergedOptions.plugins = {
      ...plugins,
      ...Object.fromEntries(setOptions.plugins.map((p) => [p.name, p])),
    };
  }

  return (
    <SunEditor
      setDefaultStyle="font-family: Arial;font-size:12px;"
      defaultValue={defaultValue}
      onChange={onChange}
      setOptions={mergedOptions}
    />
  );
}

export default SunRichEditor;
